export default {
    message: {
        impersonation: "Zamawiasz w imieniu «{name}»"
    }
}